import {combineReducers} from 'redux';
import {connectRouter} from 'connected-react-router'
import loginReducer from "./loginReducer";
import notificationReducer from "./notificationReducer";
import {reducer as formReducer} from 'redux-form';
import certificatesReducer from "./certificatesReducer";
import modalReducer from "./modalReducer";
import systemreducer from "./systemreducer";
import usersreducer from "./usersreducer";
export default (history) => combineReducers({
    router: connectRouter(history),
    auth: loginReducer,
    form: formReducer,
    notification: notificationReducer,
    certificates:certificatesReducer,
    modal:modalReducer,
    system:systemreducer,
    users:usersreducer

});